import React from "react";

import Chip from "@mui/material/Chip";
import type { SxProps } from "@mui/material/styles";

import { kebabCase } from "lodash";

type ActiveFilterChipProps = {
  label: string;
  onClick?: React.EventHandler<any>;
  onDelete?: React.EventHandler<any>;
  sx?: SxProps;
};

export default function ActiveFilterChip({
  label,
  sx,
  onClick,
  onDelete
}: ActiveFilterChipProps) {
  return (
    <Chip
      data-testid={`active-filter-${kebabCase(label)}`}
      label={label}
      onClick={onClick}
      onDelete={onDelete}
      sx={sx}
    />
  );
}
